// src/components/billing/BillingTitleChips.jsx — the Stripe controls as chips next to the plans card's title (v204,
// after the dev-VPS check: they used to sit in the plan strip). Order: «Aggiorna il metodo di pagamento», «Disdici».
//
// Same pill as the personalization badge. The card update is GREEN (an everyday, safe action); «Disdici» is NEUTRAL
// (findable, not invited). Both are Stripe controls: an operator-assigned plan (no `subscription_id`) shows neither —
// its routes answer 409 NOT_A_STRIPE_SUBSCRIPTION / NO_PAYMENT_ACCOUNT.
// `canOfferCancel(data)` is the one rule for WHEN «Disdici» shows, read from GET /billing/subscription on every
// render: a Stripe subscription, not already cancelling (⚠️ `cancel_at_period_end` is three-valued — only `true`
// hides it), and no plan change waiting for the bank (`payment_pending.kind === 'PLAN_CHANGE'` → /cancel answers
// 409 PAYMENT_PENDING).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../../constants/theme.js';

export function canOfferCancel(data) {
  return !!data?.subscription_id
    && data.cancel_at_period_end !== true
    && data.payment_pending?.kind !== 'PLAN_CHANGE';
}

const chip = (tone, busy) => ({
  display: 'inline-flex', alignItems: 'center', padding: '4px 12px', borderRadius: RADII.pill,
  border: 'none', background: tone.bg, color: busy ? COLORS.textTertiary : tone.fg,
  fontFamily: FONT_SANS, fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap',
  cursor: busy ? 'not-allowed' : 'pointer',
});

export default function BillingTitleChips({ data, busy, onUpdateCard, onCancel }) {
  const { t } = useTranslation('billing');
  if (!data?.subscription_id) return null;
  return (
    <>
      <button type="button" onClick={onUpdateCard} disabled={busy} style={chip(SEMANTIC.verde, busy)}>
        {t('current.updateCard')}
      </button>
      {canOfferCancel(data) && (
        <button type="button" onClick={onCancel} disabled={busy} style={chip(SEMANTIC.neutro, busy)}>
          {t('current.cancel')}
        </button>
      )}
    </>
  );
}
